import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Navbar from "@/components/navbar.vue";

Vue.config.productionTip = false;

Vue.component("navbar", Navbar);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
